const BaseModel = require('lib/base_model')
const log = require('log').create('dialog', 'model'); // eslint-disable-line


const DialogModel = BaseModel.extend({

    calculated_values: {
        show_head() {
            let show_head = false
            if (this.get('title') || this.get('close_button')) {
                show_head = true
            }
            return show_head
        },
    },

})

module.exports = DialogModel
